"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ExternalLink = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/ExternalLink"));
var _default = function _default() {
  return {
    text: 'Get started',
    showIcon: true,
    icon: /*#__PURE__*/_react.default.createElement(_ExternalLink.default, {
      style: {
        fontSize: '1.25em',
        position: 'absolute',
        top: 'calc(50% - 1.2em/2)'
      }
    }),
    vertical: 'Estate Planning'
  };
};
exports.default = _default;